import styled from 'styled-components';

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
`;

export const TableBody = styled.div``;

export const TableHeader = styled.div<{ $columnWidths: string[] }>`
  display: grid;
  grid-template-columns: ${({ $columnWidths }) => $columnWidths.join(' ')};
  background-color: var(--white-100);
  padding: var(--spacing-03);
  border-bottom: 1px solid var(--gray-10);
  gap: var(--spacing-03);
  width: 100%;
`;

export const TableRow = styled.div<{ $columnWidths: string[] }>`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ $columnWidths }) => $columnWidths.join(' ')};
  padding: var(--spacing-03);
  border-bottom: 1px solid var(--gray-10);
  gap: var(--spacing-03);
  align-items: center;

  &:nth-child(even) {
    border-bottom: 2px solid var(--gray-10);
  }
`;

export const HeaderCell = styled.div`
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-02);
  letter-spacing: var(--letter-spacing-01);
  color: var(--gray-60);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

export const Cell = styled.div`
  font-size: var(--font-size-base);
  line-height: var(--line-height-02);
  color: var(--gray-100);
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;
